import React, { useEffect, useState } from "react";
import { Home } from './home';
import { generalService } from '../services/general.service';
import $ from 'jquery';

export const Contact = () => {
    return (<Home />);
}
